var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_839_4228",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_839_4228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_2",
    d: "M24.3558 25.1923L16.5289 17.3654C15.9039 17.8975 15.1851 18.3094 14.3726 18.601C13.5601 18.8927 12.7437 19.0385 11.9233 19.0385C9.92118 19.0385 8.2267 18.3455 6.83983 16.9595C5.45316 15.5734 4.75983 13.88 4.75983 11.8792C4.75983 9.87813 5.45285 8.18323 6.83889 6.79448C8.22493 5.40594 9.91837 4.71167 11.9192 4.71167C13.9202 4.71167 15.6151 5.405 17.0039 6.79167C18.3924 8.17854 19.0867 9.87302 19.0867 11.8751C19.0867 12.7436 18.9328 13.5842 18.6251 14.3967C18.3174 15.2092 17.9136 15.9039 17.4136 16.4807L25.2405 24.3079L24.3558 25.1923ZM11.9233 17.7885C13.5818 17.7885 14.982 17.2176 16.1239 16.0757C17.2658 14.9341 17.8367 13.5339 17.8367 11.8751C17.8367 10.2164 17.2658 8.81615 16.1239 7.67448C14.982 6.53261 13.5818 5.96167 11.9233 5.96167C10.2645 5.96167 8.86431 6.53261 7.72264 7.67448C6.58076 8.81615 6.00983 10.2164 6.00983 11.8751C6.00983 13.5339 6.58076 14.9341 7.72264 16.0757C8.86431 17.2176 10.2645 17.7885 11.9233 17.7885Z",
    fill: "#232323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ee42db1a6f8a18afd79794f919ca1a96.svg";
export { ForwardRef as ReactComponent };